import { Checkbox as NCheckbox, type CheckboxProps as Props } from '@heroui/react';
import { type Control, Controller, type FieldValues, type Path, type PathValue } from 'react-hook-form';

export const CheckBox = (props: Props) => {
  return <NCheckbox radius='sm' {...props} />;
};

export interface FormCheckBoxProps<T extends FieldValues> extends Props {
  name: Path<T>;
  control: Control<T, unknown>;
  defaultValue?: PathValue<T, Path<T>>;
  shouldUnregister?: boolean;
}

export const FormCheckBox = <T extends FieldValues>({
  control,
  name,
  children,
  defaultValue,
  shouldUnregister = true,
  ...rest
}: FormCheckBoxProps<T>) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={control}
      shouldUnregister={shouldUnregister}
      render={({ field: { onChange, onBlur, value }, fieldState: { invalid, isDirty } }) => {
        return (
          <CheckBox
            value={value}
            radius='md'
            isInvalid={isDirty && invalid}
            onBlur={onBlur}
            onChange={onChange}
            isSelected={value}
            {...rest}
          >
            {children}
          </CheckBox>
        );
      }}
    />
  );
};
